import * as RestAPI from '../../restApi'

export const updateUserEmail = (userId, data) => {
  return new Promise((resolve, reject) => {
    RestAPI.POST(`/admin/users/${userId}/email`, data, 'v2Admin')
      .then((result) => resolve(result))
      .catch((error) => reject(error))
  })
}
